import { AppFacade, AuthService } from "@app/core/app-services";
import { filter } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "../app-services/app.facade";
import * as i2 from "../app-services/auth";
var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(appFacade, auth) {
        this.appFacade = appFacade;
        this.auth = auth;
    }
    AuthGuardService.prototype.canActivate = function () {
        var _this = this;
        this.appFacade
            .isAuthenticated()
            .pipe(filter(function (status) { return status === false; }))
            .subscribe(function () {
            _this.auth.handleAuthentication();
        });
        return true;
    };
    AuthGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(i0.ɵɵinject(i1.AppFacade), i0.ɵɵinject(i2.AuthService)); }, token: AuthGuardService, providedIn: "root" });
    return AuthGuardService;
}());
export { AuthGuardService };
